import React, { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import Tree from "@components/ui/Tree";
import HStack from "@components/layout/HStack";
import { CategoryOperator } from "@shared/types/enums/globalEnum";
import { useAppConfigStore } from "@/pages/taskpane/shared/stores";

type Props = {
  categoryOperator?: CategoryOperator;
  iShowFooter?: boolean;
  categorySelected?: number[];
  onClose?: () => void;
  onClear?: () => void;
  onApply?: (selectedIds: number[], operator?: CategoryOperator) => void;
};
const SelectCategoryForm = ({
  categoryOperator,
  iShowFooter = true,
  categorySelected,
  onClose,
  onClear,
  onApply,
}: Props) => {
  const { t } = useTranslation();
  const { categoryTree } = useAppConfigStore();
  const [operator, setOperator] = useState<CategoryOperator | undefined>(categoryOperator || undefined);

  const handleClear = () => {
    onClear?.();
  };

  const handleApply = (selectedIds: number[]) => {
    if (!operator){
      onApply?.(selectedIds);
    }else{
      onApply?.(selectedIds, operator as CategoryOperator);
    }
  };

  return (
    <div className="">
      {operator ? (
        <div className="w-full px-2 py-2 border-b border-lightGray dark:border-darkMediumGray text-darkGray dark:text-white">
          <HStack gap={4} className="justify-start">
            <HStack gap={1} className="items-center">
              <input
                type="radio"
                id="and-radio"
                name="operator"
                value={CategoryOperator.And}
                checked={operator === CategoryOperator.And}
                onChange={(e) => setOperator(e.target.value as CategoryOperator)}
                className="w-3 h-3"
              />
              <label htmlFor="and-radio" className="text-xs cursor-pointer">
                {t("And")}
              </label>
            </HStack>
            <HStack gap={1} className="items-center">
              <input
                type="radio"
                id="or-radio"
                name="operator"
                value={CategoryOperator.Or}
                checked={operator === CategoryOperator.Or}
                onChange={(e) => setOperator(e.target.value as CategoryOperator)}
                className="w-3 h-3"
              />
              <label htmlFor="or-radio" className="text-xs cursor-pointer">
                {t("Or")}
              </label>
            </HStack>
          </HStack>
        </div>
      ) : null}

      <Tree
        className="w-full"
        nodeTree={categoryTree}
        iShowFooter={iShowFooter}
        selected={categorySelected || []}
        maxHeight={300}
        onClose={onClose}
        onClear={handleClear}
        onApply={handleApply}
        isSingleSelect={false}
      />
    </div>
  );
};

export default memo(SelectCategoryForm);
